        
import ModalFormContext from '../../../store/ModalFormContext';
import {useContext} from 'react';   


const FormModalButton = ({ url, alter_url_func, callbackFunc, className, action_icon, children, disabled=false, formData, ...props}) =>{
    const modalFormContext = useContext(ModalFormContext);

    const setForm = (e) => {
        e.preventDefault();
        e.stopPropagation(); // stops React Router intercept
        if(disabled){
            return
        }
        if(formData){
            if(!url.includes('?')){
                url = url + '?' + new URLSearchParams(formData).toString()
            }
            else{
                url = url + '&' + new URLSearchParams(formData).toString()
            }
        }
        if(alter_url_func){
            url = alter_url_func(url)
        }
        modalFormContext.openModal()
        const { callbackFunc: _, ...restProps } = props;
        modalFormContext.setModalForm({...restProps, url:url, callbackFunc: callbackFunc});
    }
    return  <a type="button" onClick={setForm} className={`${disabled ? 'disabled' : ''} action-button ${className}`}>
            {children}
        </a>
}

export default FormModalButton;